import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { FiCheckCircle } from 'react-icons/fi';

const PagamentoSucessoPage = () => {
  const history = useHistory();
  return (
    <Box sx={{ bgcolor: '#f5f5f5', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Box sx={{ maxWidth: '98%', mx: 'auto', py: 3, width: '100%', maxWidth: 480 }}>
        <Box
          sx={{
            p: { xs: 2.5, md: 3 },
            borderRadius: 2.5,
            border: '1px solid',
            borderColor: 'grey.200',
            boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
            bgcolor: '#fff',
            textAlign: 'center',
          }}
        >
          <FiCheckCircle size={56} color="#16a34a" style={{ marginBottom: 16 }} />
          <Typography variant="h5" sx={{ fontWeight: 700, color: '#1a1a2e', mb: 1 }}>
            Pagamento realizado com sucesso!
          </Typography>
          <Typography variant="body1" sx={{ color: '#999', mb: 3 }}>
            Seu pagamento foi confirmado. Obrigado por comprar conosco!
          </Typography>
          <Button
            fullWidth
            variant="contained"
            onClick={() => history.push('/')}
            sx={{
              bgcolor: '#1a1a2e',
              color: '#fff',
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: 1.5,
              py: 1.2,
              '&:hover': { bgcolor: '#16213e' },
            }}
          >
            Voltar para a Home
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default PagamentoSucessoPage;
